<div class="row justify-content-center align-items-center h-100">
  <div class="col-4 pe-0">
    <app-password-recovery></app-password-recovery>
  </div>
</div>
